<div class="sp-width__full sp-row__space sp-wrap">
  <div class="sp-row__align">
    <mat-icon
      *ngIf="buyer?.is_confirmed"
      class="material-symbols-outlined"
      color="accent">
      check_circle
    </mat-icon>
    <mat-icon
      *ngIf="!buyer?.is_confirmed"
      class="material-symbols-outlined"
      color="primary">
      do_not_disturb_on
    </mat-icon>
    <span
      *ngIf="buyer?.firstname && buyer?.lastname"
      class="sp-color__primary sp-margin__left">
      {{ buyer?.firstname }} {{ buyer?.lastname }}
    </span>

    <span
      *ngIf="!buyer?.firstname || !buyer?.lastname"
      class="sp-color__primary sp-margin__left">
      {{ buyer?.phone?.prefix }} {{ buyer?.phone?.value }}
    </span>
  </div>

  <div class="sp-row__align">
    <span class="sp-color__primary"> {{ buyer?.created_at | date : 'short' }} </span>
  </div>
  <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__top" />
</div>
